import { Box } from "@mui/material";
import { State, GridCoord } from "modules/shop_grid/types";
import GridCell from "components/GridCell";

interface ShopGridViewProps {
  grid: State.Grid;
  selectedCells: GridCoord[];
  toggleCell: (cell: State.Cell) => void;
  mode: "inventory" | "furniture";
  showDiff?: boolean;
  viewMode?: boolean;
  maxHeight?: string;
  modeCell?: "comparator";
}

const CELL_SIZE = 50;
const GRID_GAP = 2;

const ShopGridView = ({ grid, selectedCells, toggleCell, mode, maxHeight, showDiff = false, viewMode = false, modeCell }: ShopGridViewProps) => (
  <Box sx={{ maxWidth: "100%", overflow: "auto", maxHeight }}>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: `25px repeat(${grid.width}, ${CELL_SIZE}px)`,
        gridTemplateRows: `25px repeat(${grid.height}, ${CELL_SIZE}px)`,
        gridGap: `${GRID_GAP}px`,
        maxHeight: "max-content",
        width: "max-content",
        zoom: { xs: 0.5, sm: 1 },
      }}
    >
      <Box
        sx={{
          gridRow: 1,
          gridColumn: 1,
          position: "sticky",
          left: 0,
          top: 0,
          background: "white",
          zIndex: "2",
        }}
      />
      {grid.lines.map((line, yAxis) => (
        <Box
          key={yAxis}
          sx={{
            gridRow: yAxis + 2,
            gridColumn: 1,
            position: "sticky",
            left: 0,
            background: "white",
            lineHeight: `${CELL_SIZE}px`,
            zIndex: "2",
          }}
        >
          {yAxis + 1}
        </Box>
      ))}
      {grid.lines[0].map((cell, xAxis) => (
        <Box
          key={xAxis}
          sx={{
            gridRow: 1,
            gridColumn: xAxis + 2,
            position: "sticky",
            top: 0,
            background: "white",
            textAlign: "center",
            width: `${CELL_SIZE + GRID_GAP}px`,
            zIndex: "2",
          }}
        >
          {xAxis + 1}
        </Box>
      ))}
      {grid.lines.map((line, yAxis) =>
        line.map((cell, xAxis) => {
          const isEmpty = !cell.furniture;
          const selected = selectedCells.some((selectedCell) => selectedCell === cell);

          if (isEmpty && mode === "inventory") return null;

          return (
            <GridCell
              key={`${yAxis}-${xAxis}`}
              mode={mode}
              cell={cell}
              dimmed={selectedCells.length > 0}
              onClick={() => toggleCell(cell)}
              selected={selected}
              interactive
              showDiff={showDiff}
              viewMode={viewMode}
              modeCell={modeCell}
            />
          );
        })
      )}
    </Box>
  </Box>
);

export default ShopGridView;
